import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/api/Employee/LogIn",
    method: "post",
    data,
  });
}

export function GetPlayer(data) {
  return request({
    url: "/api/Player/GetPlayer",
    method: "get",
    data,
  });
}

export function GetUserRank(data) {
  return request({
    url: "/api/Game/GetUserRank",
    method: "get",
    data,
  });
}
